export default "__VITE_ASSET__e79ece28__"